import { fetchOrderAttributes } from '@/entities/attributes/thunks/fetchOrderAttributes'
import { fetchColumnDefinitions } from '@/entities/columnDefinitions/thunks/fetchColumnDefinitions'
import { fetchDepotLites } from '@/entities/depots/thunks/fetchDepotLites'
import { fetchScenarios } from '@/entities/schedules/thunks/fetchScenarios'
import { completeLoadingState } from '@/entities/userInterface/slices/loaderSlice'
import { setCurrentScreen } from '@/entities/userInterface/slices/userInterfaceSlice'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchOrderInboxCount } from './fetchOrderInboxCount'

// This asynchronous function is designed to initialize and set up global state in the Redux store related to the operations planning page.
export const setupPlanning = createAsyncThunk('planning/setup', async (_, { dispatch }) => {
  await Promise.allSettled([
    dispatch(setCurrentScreen('planning')),
    dispatch(fetchDepotLites()),
    dispatch(fetchOrderAttributes()),
    dispatch(fetchColumnDefinitions({ gridTypeName: 'planningInbox' })),
    dispatch(fetchColumnDefinitions({ gridTypeName: 'planningShift' })),
    dispatch(fetchColumnDefinitions({ gridTypeName: 'scenarioUnassigned' })),
    dispatch(fetchScenarios({ scenarioIds: [] })),
    dispatch(fetchOrderInboxCount()),
  ])

  dispatch(completeLoadingState())
})